import React from 'react'
import { Box, Typography, IconButton, Divider } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'

interface YearNavigationHeaderProps {
  selectedYear: number
  canNavigateToPreviousYear: boolean
  canNavigateToNextYear: boolean
  navigateToPreviousYear: () => void
  navigateToNextYear: () => void
  isLoading?: boolean
  dataTestId?: string
}

function YearNavigationHeader({
  selectedYear,
  canNavigateToPreviousYear,
  canNavigateToNextYear,
  navigateToPreviousYear,
  navigateToNextYear,
  isLoading = false,
  dataTestId = 'year-navigation'
}: YearNavigationHeaderProps) {
  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="baseline"
        p={0.2}
        data-testid={dataTestId}
      >
        <IconButton
          onClick={navigateToPreviousYear}
          disabled={!canNavigateToPreviousYear || isLoading}
          data-testid={`${dataTestId}-prev-year-btn`}
          sx={{ position: 'relative', top: '3px' }}
        >
          <ChevronLeft />
        </IconButton>
        
        <Typography
          variant="h6"
          component="div"
          sx={{ minWidth: '80px', textAlign: 'center' }}
          data-testid={`${dataTestId}-current-year`}
        >
          {selectedYear}
        </Typography>
        
        <IconButton
          onClick={navigateToNextYear}
          disabled={!canNavigateToNextYear || isLoading}
          data-testid={`${dataTestId}-next-year-btn`}
          sx={{ position: 'relative', top: '3px' }}
        >
          <ChevronRight />
        </IconButton>
      </Box>
      <Divider />
    </>
  )
}

export default YearNavigationHeader